import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";
import Typography from '@mui/joy/Typography';

// components
import BaseApi from "../../utils/BaseApi";
import RouteStateAgentCall from "./RouteStateAgentCall";


class RouteStateAgentCalls extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            route_state_agent_calls: [],
        };
    }

    async componentDidMount() {
        await this.retrieveRouteStateAgentCalls();
    }

    async retrieveRouteStateAgentCalls() {
        const url = 'route_state_agent_call/';
        const params = {
            state: this.props.state.id
        };
        const api = new BaseApi();
        let response = await api.get(url, params);
        await this.setState(
            {
                route_state_agent_calls: response.data.results
            }
        );
    }

    render() {
        if (!this.state.route_state_agent_calls) {
            return (<CircularProgress/>)
        }
        if (!this.state.route_state_agent_calls.length) {
            return null
        }
        return (
            <Stack>
                <Typography level={'body-sm'} sx={{mb: 1}}>
                    AI-помощник
                </Typography>
                <Stack>
                    {
                        this.state.route_state_agent_calls.map((call) => (
                            <RouteStateAgentCall
                                call={call}
                            />
                        ))
                    }
                </Stack>
            </Stack>

        )
    }
}

export default RouteStateAgentCalls;
